import { Component, ElementRef } from '@angular/core';
import { BaseDesignerComponent } from '../../base/base-designer-component';
import { RichTextAttribute } from 'app/private/sxfdesigner/types/designer-attribute-type';

@Component({
    selector: 'sx-quotationresult-designer',
    templateUrl: './quotationResultDesigner.component.html'
})

export class BaseDynamicListDesignerComponent extends BaseDesignerComponent {
    hasDynamicList = true;

    dynamicListAttributes: RichTextAttribute[];

    newItemName: string;
    newItemLabel: string;

    constructor(container: ElementRef) {
        super(container, 'DynamicListAttributes');
    }

    get jsonListProperty(): string {
        return 'dynamicListAttributes';
    }

    loadDefaults() {
        super.loadDefaults();
        this.dynamicListAttributes = [];
    }

    loadState(jsonRoot: any) {
        this.dynamicListAttributes = [];

        const jsonListItems = jsonRoot[this.jsonListProperty];
        if (jsonListItems){
            jsonListItems.forEach(item => {
                const newAttribute = new RichTextAttribute(this.controlContext,
                                                        item.name,
                                                        item.label);
                this.dynamicListAttributes.push(newAttribute);
            });
        }
    }

    getDesignerInfo(): any {
        const info = super.getDesignerInfo();
        info[this.jsonListProperty] = this.dynamicListAttributes.map(attr => {
            return { name: attr.name, label: attr.label};
        });

        return info;
    }

    addNewItem() {
        const existingItem = this.dynamicListAttributes
            .find(item => item.name === this.newItemName);
        if (existingItem) {
            return;
        } else {
            const newAttribute = new RichTextAttribute(this.controlContext,
                                                       this.newItemName,
                                                       this.newItemLabel);
            this.dynamicListAttributes.push(newAttribute);

            this.newItemLabel = undefined;
            this.newItemName = undefined;
        }
    }

    removeItem(itemName: string) {
        const itemIndex = this.dynamicListAttributes
            .findIndex(item => item.name === itemName);
        this.dynamicListAttributes.splice(itemIndex, 1);
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/designers/layout/flow-actions/base.dynamic.list.component.ts